import { createAction } from 'typesafe-actions';
import { ACTIONS, ToastItemType } from './types';

export const addToastAction = createAction(ACTIONS.ADD_TOAST)<ToastItemType>();

export const removeToastAction = createAction(ACTIONS.REMOVE_TOAST)();

export const addBettingTimeToastAction = createAction(
  ACTIONS.ADD_BETTING_TIME_TOAST,
)<ToastItemType>();

export const removeBettingTimeToastAction = createAction(ACTIONS.REMOVE_BETTING_TIME_TOAST)();
